import { useTranslations } from "next-intl";

interface PromoBannerProps {
  variant: "blue" | "red";
  className?: string;
  children?: React.ReactNode; // <-- Añadimos esto para poder recibir un texto personalizado
}

const VARIANTS = {
  blue: "bg-brand-navy dark:bg-brand-navy-lighter",
  red: "bg-brand-red",
} as const;

export function PromoBanner({ variant, className = "", children }: PromoBannerProps) {
  const t = useTranslations("promoBanner");

  return (
    <div
      role="note"
      className={`w-full px-4 py-3 text-center text-xs font-extrabold uppercase tracking-wide text-white shadow-md xs:text-base ${VARIANTS[variant]} ${className}`}
    >
      {children ?? t("items.0")}
    </div>
  );
}